module.exports = __webpack_public_path__ + "media/images/battery-20-1d98812ff55b6a7a73c5bd9ea443c832.png";